import { useState } from 'react'
import { CREDIT_PACKAGES } from '../pricing/PricingPackages'
import PricingPackageCard from '../pricing/PricingPackageCard'
import { getApiBaseUrl } from '../../utils/api'
import { useToast } from '../../context/ToastContext'

export default function PricingPackagesModal({ onClose }) {
  const [isProcessing, setIsProcessing] = useState(false)
  const { showToast } = useToast()

  const handlePurchase = async (pkg) => {
    if (!pkg) return

    try {
      setIsProcessing(true)
      const apiUrl = getApiBaseUrl()

      // Call API to create Stripe Checkout session
      const response = await fetch(`${apiUrl}/v1/payment/checkout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
        body: JSON.stringify({
          credit_package_id: pkg.id,
          success_url: `${window.location.origin}/payment/success`,
          cancel_url: `${window.location.origin}/payment/cancel`,
        }),
      })

      if (!response.ok) {
        throw new Error('Failed to create checkout session')
      }

      const data = await response.json()

      // Redirect to Stripe Checkout
      if (data.checkout_url) {
        window.location.href = data.checkout_url
      } else {
        showToast('error', 'Checkout URL not provided', 'Error')
        setIsProcessing(false)
      }
    } catch (error) {
      console.error('Checkout error:', error)
      showToast('error', error.message, 'Checkout Failed')
      setIsProcessing(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-30 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto animate-fade-in relative">
        {/* Processing Overlay */}
        {isProcessing && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center z-10 rounded-xl">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 flex flex-col items-center">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mb-4"></div>
              <p className="text-lg text-gray-900 dark:text-white">Redirecting to checkout...</p>
            </div>
          </div>
        )}

        {/* Header */}
        <div className="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-8 py-6 flex justify-between items-center">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">Pricing</h2>
          <button
            onClick={onClose}
            disabled={isProcessing}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 text-3xl disabled:opacity-50"
          >
            ×
          </button>
        </div>

        {/* Package Cards */}
        <div className="p-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {CREDIT_PACKAGES.map(pkg => (
              <PricingPackageCard
                key={pkg.id}
                pkg={pkg}
                onPurchase={handlePurchase}
              />
            ))}
          </div>

          {/* Simple Footer */}
          <div className="mt-6 text-center text-sm text-gray-500 dark:text-gray-400">
            💳 Secure checkout powered by Stripe
          </div>
        </div>
      </div>
    </div>
  )
}
